import React from "react";
import { useTranslation } from "react-i18next";
import { AmountBOA } from "../common/amountBOA";

const BalanceBox = ({ totalSelfPayment, totalPayment }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="BalanceText alignRight">
        <p className="hidde"> {t("Self")}</p>
        <div className="label-name"> {t("Total")}</div>
        <div className="label-name"> {t("Spendable")}</div>
      </div>
      <div className="BalanceText">
        <p> {t("Self_Balance")}</p>
        <div className="balanceLabel">
          <AmountBOA amount={totalSelfPayment.total} hideSuffix={true} />
        </div>
        <div className="balanceLabel">
          <AmountBOA amount={totalSelfPayment.spendable} hideSuffix={true} />
        </div>
      </div>
      <div className="BalanceText">
        <p> {t("Total_Balance")}</p>
        <div className="balanceLabel">
          <AmountBOA amount={totalPayment.total} hideSuffix={true} />
        </div>
        <div className="balanceLabel">
          <AmountBOA amount={totalPayment.spendable} hideSuffix={true} />
        </div>
      </div>
    </>
  );
};

const balanceAreEqual = (prevProps, nextProps) => {
  return (
    prevProps.totalSelfPayment === nextProps.totalSelfPayment &&
    prevProps.totalPayment === nextProps.totalPayment
  );
};
export default React.memo(BalanceBox, balanceAreEqual);
